// Role types
export const ROLES = {
  ADMIN: 0,
  STAFF: 1,
};

export const mockMenuListAdmin = [
  {
    code: "dashboard",
    label: {
      en_US: "Quản trị",
    },
    icon: "permission",
    path: "/",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    code: "question",
    label: {
      en_US: "Quản lý dự án",
    },
    icon: "productot",
    path: "/project",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    code: "userType",
    label: {
      en_US: "Quản lý đối tượng",
    },
    icon: "userType",
    path: "/userType",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    code: "ragFile",
    label: {
      en_US: "Quản lý file dữ liệu",
    },
    icon: "ragFile",
    path: "/ragFile",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    code: "question",
    label: {
      en_US: "Quản lý câu hỏi",
    },
    icon: "question",
    path: "/question",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    code: "log",
    label: {
      en_US: "Quản lý Log",
    },
    icon: "log",
    path: "/log",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    code: "user",
    label: {
      en_US: "Quản lý thành viên",
    },
    icon: "user",
    path: "/user",
    roles: [ROLES.ADMIN],
  },
];
